export const isMac = navigator.platform.toUpperCase().includes('MAC')

export function altShortcut(key: string): string {
  return isMac ? `⌥${key}` : `Alt+${key}`
}

export function metaShortcut(key: string): string {
  return isMac ? `⌘${key}` : `Ctrl+${key}`
}
